import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

//TODO remove align-items flex on body on willmmount
@connect((store) => {
    return { };
})
class HasFpact extends React.Component {
    constructor(props) {
        super(props);
        this.goToFpactList = this.goToFpactList.bind(this);
        this.goToPharmacyList = this.goToPharmacyList.bind(this);
        this.goToClinicList = this.goToClinicList.bind(this);
    }

    // componentWillMount() {
    //     document.getElementById('root').style.height = 'auto';
    // }

    // componentWillUnmount() {
    //     document.getElementById('root').style.height = '100%';
    // }
   
    goToFpactList() {
        this.props.history.push('/fpactlist');
    }

    goToClinicList() {
        this.props.history.push('/clinics');
    }

    goToPharmacyList() {
        this.props.history.push('/pharmacylist');
    }

    render() {
        return (
            <div>
                <img className="has-fpact-image" src="./images/hasFpact.png"/>
                <h1 className="ec__font__title text-center">You have a few options</h1>
                <div className="card-container">
                    <div className="card">
                        <div className="card__content">
                            <p className="card__title">
                                Local pharmacy that takes FPACT
                            </p>
                            <p className="card__text">
                                $0
                            </p>
                        </div>
                        <div className="card__actions">
                            <a className="card__action" onClick={this.goToFpactList}>See details</a>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card__content">
                            <p className="card__title">
                                Drop-in clinics (no appointment needed)
                            </p>
                            <p className="card__text">
                                $0 - $20
                            </p>
                        </div>
                        <div className="card__actions">
                            <a className="card__action" onClick={this.goToClinicList}>See list</a>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card__content">
                            <p className="card__title">
                                Other clinics (may need appointment)
                            </p>
                            <p className="card__text">
                                $0 - $25
                            </p>
                        </div>
                        <div className="card__actions">
                            <a className="card__action" onClick={this.goToPharmacyList}>See list</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default HasFpact;



// WEBPACK FOOTER //
// ./src/components/screens/HasFpact.js